import { formatSettlementHeaderDate } from "./date";

const getClientDisplayName = (caseDetail) => {
  if (!caseDetail) {
    return "";
  }

  return caseDetail?.client?.name ?? caseDetail?.clientName ?? caseDetail?.client_name ?? "";
};

const getAttorneyDisplayName = (caseDetail) => {
  if (!caseDetail) {
    return "";
  }

  return caseDetail?.lawFirmName ?? "";
};

export const getSettlementHeaderFields = (caseDetail) => [
  { label: "Client", value: getClientDisplayName(caseDetail) },
  { label: "Attorney", value: getAttorneyDisplayName(caseDetail) },
  {
    label: "Case Name",
    value: caseDetail?.name ? caseDetail.name : getClientDisplayName(caseDetail) || "",
  },
  {
    label: "Date Of Accident",
    value: formatSettlementHeaderDate(caseDetail?.dateOfAccident ?? ""),
  },
];
